import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBox
 */
export const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 40px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 20px;
  padding-bottom: 28px;
  width: 400px;
  min-width: 320px;
  max-width: 80vw;

  header {
    border-bottom: 1px solid #e6e6e6;

    h2 {
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 41px;
    }
  }

  footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    justify-content: center;
    column-gap: 28px;
    max-width: 320px;
    flex-direction: row;
    bottom: 0;
    right: 0;
    width: 100%;
    text-align: right;
    padding: 24px 46px 0px 46px;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
    margin-top: 27px;
    color: #5e6366;
    white-space: normal;
    word-break: normal;
  }

  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 20px;
    min-width: 104px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    color: #fff;
    background-color: #3c71dd;
  }

  &.MuiButton-containedSecondary {
    color: #fff;
    background-color: #aeaeae;

    &:hover {
      background-color: #a8a8a8;
    }
  }
`;
